// Libraries
import { NgModule, }    from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';

import { AlertBoxComponent, PaginatorComponent } from './components';

import { TranslateModule } from '@ngx-translate/core';

// AoT requires an exported function for factories

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        JsonpModule,
        TranslateModule,
    ],
    declarations: [
        AlertBoxComponent,
        PaginatorComponent,
    ],
    exports: [
        // Modules
        CommonModule,
        FormsModule,
        HttpModule,
        JsonpModule,
        // Components
        AlertBoxComponent,
        PaginatorComponent,
        TranslateModule,
    ]
})
/**
 * The SharedModule which will define the modules, components & directives that will
 * be used again in other feature modules. It 's different with the CoreModule which
 * will define the components, directives that only use one time in the main AppModule.
 */
export class SharedModule { }


// WEBPACK FOOTER //
// ./src/common/modules/shared/SharedModule.ts